var $a2115d90ea08917b$exports = {};
$a2115d90ea08917b$exports = {
    "collectionLabel": `Forslag`
};


export {$a2115d90ea08917b$exports as default};
//# sourceMappingURL=da-DK.mjs.map
